import { lazy } from 'react';
import { DECISION_MAKER_ID, HOT_POTATO_ID } from '@momentum/modules/manifests';
import { clientRenderers, registerBoard3D } from '@momentum/modules/client';

/**
 * Registers the client-only 3D board renderer with `@momentum/modules`'s registry slot. Call this once at app
 * startup, before (or as part of) mounting the React tree — e.g. in `main.tsx`:
 *
 * ```ts
 * import { setupRenderers } from './renderers/index.ts';
 * setupRenderers();
 * ```
 *
 * `board3d.tsx` is only fetched (and only then imports `three`) the first time a board renderer actually
 * switches to the "3D" mode; the 2D-only path never loads either module. Safe to call more than once.
 */
export function setupRenderers(): void {
  clientRenderers[HOT_POTATO_ID] = { renderer: HOT_POTATO_ID, Component: lazy(() => import('./hotPotato.tsx')) };
  registerBoard3D(lazy(() => import('./board3d.tsx')));
  clientRenderers[DECISION_MAKER_ID] = { renderer: DECISION_MAKER_ID, Component: lazy(() => import('./decisionMaker.tsx')) };
}
